// WARNING: DO NOT EDIT. This file is automatically generated by CDP Build. It will be overwritten.

export const cdpenv = {
		"TennantAPI":"https://tenant.surecanpay-uat-cert.com/",
	"FilesURL":"https://files.surecanpay-uat-cert.com/settlement",

};
